import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FormHelperText } from '@mui/material';

type TextFiled = {
  type: 'text' | 'time' | 'date' | 'password' | 'textarea' | 'email' | 'number' | 'datetime-local';
  name: string;
  label: string;
  helper?: string;
  fullWidth?: boolean;
  showErrorMessage?: boolean;
  rule?: RegisterOptions;
  formHelperTextProps?: {};
};

type InputPartialProps = Omit<TextFieldProps, keyof TextFiled>;

export type CustomTextFieldProp = TextFiled & InputPartialProps;

const CustomTextField: React.FC<TextFiled & InputPartialProps> = ({
  name,
  type,
  label,
  rule,
  helper,
  fullWidth = true,
  showErrorMessage = true,
  formHelperTextProps,
  ...inputProps
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rule}
      defaultValue={''}
      render={({ field, fieldState }) => {
        return (
          <>
            <TextField
              fullWidth={fullWidth}
              {...field}
              {...inputProps}
              type={type}
              label={label}
              error={!!fieldState.error}
              FormHelperTextProps={formHelperTextProps}
              helperText={showErrorMessage ? fieldState.error?.message : null}
            />
            {helper && <FormHelperText>{helper}</FormHelperText>}
          </>
        );
      }}
    />
  );
};

export default CustomTextField;
